import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import withWebView from 'ggApp/shared/hocs/withWebView';
import { Intercom } from 'ggApp/modules/intercom';
import { CookiePolicy } from 'ggApp/modules/cookiePolicy';
import GaAuthenticationReporter, { GaAnalyticsGTMLoader } from 'ggApp/modules/gaAnalytics';
import { NotificationComponents_Wrap as NotificationComponentsWrap } from 'ggApp/modules/notification';
import CustomerSupport from 'ggApp/modules/customerSupport';
import { BrazeLoader } from 'braze';
import { SnowplowLoader } from 'snowplow';
import { TouchIconLinks } from '../touchIconLinks';

const CookiePolicyWithChecker = withWebView(CookiePolicy);

const AppShell = ({ children }) => (
    <Suspense fallback={<CircleLoader />}>
        <SnowplowLoader />
        <CustomerSupport />
        <Intercom />
        <TouchIconLinks />
        <GaAnalyticsGTMLoader />
        <GaAuthenticationReporter />
        <BrazeLoader>{children}</BrazeLoader>
        <NotificationComponentsWrap />
        <CookiePolicyWithChecker />
    </Suspense>
);

AppShell.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AppShell;
